import React, { useState } from 'react';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';

import { Dialog } from '../others/Dialog';
import { LayoutActionSelection } from '../../screens/actionSelection/layout/LayoutActionSelection';

const ActionSelectionField = ({
    field,
    value,
    onChange,
    error = false,
    helperText = ''
}) => {
    const [open, setOpen] = useState(false);
    const configuration = field.configuration || field.config || {
        form: field.form || []
    };
    const isMultiple = field.multiple !== false;
    const selectedCount = isMultiple
        ? (Array.isArray(value) ? value.length : 0)
        : (value && typeof value === 'object' ? Object.keys(value).length : 0);

    return (
        <FormControl fullWidth error={error} required={field.required}>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>
                {field.label}
            </Typography>
            <Button
                variant="outlined"
                startIcon={<EditIcon />}
                onClick={() => setOpen(true)}
                color={error ? 'error' : 'primary'}
            >
                {selectedCount > 0
                    ? (isMultiple ? `${selectedCount} registro(s)` : 'Editar información')
                    : 'Agregar información'}
            </Button>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}

            <Dialog
                openDialog={open}
                widthDialog="lg"
                styleDialog={{ width: '100%' }}
                title={field.label}
                styleContent={{ pt: 2 }}
                content={
                    <LayoutActionSelection
                        embedded
                        config={configuration}
                        value={value}
                        multiple={isMultiple}
                        allowSchemaEditing={field.allowSchemaEditing === true}
                        onChange={(newValue) => onChange(field.id, newValue)}
                        onClose={() => setOpen(false)}
                    />
                }
                onClose={() => setOpen(false)}
            />
        </FormControl>
    );
};

export default ActionSelectionField;
